const runHooks = [];

function add(fnc, addToStart) {
  // the addToStart is a last minute change to keep the order 
  // of non validated modules in the same order they appear in the DIF form
  if(addToStart) {
    runHooks.unshift(fnc);
  } else {
    runHooks.push(fnc);
  }
}

function run() {
  return runHooks.map(hook => hook()).filter(formName => typeof formName === 'string');
}

const service = {
  run,
  add
};

window.validationHookService = service;

module.exports = service;
